export default "__VITE_ASSET__lxV08LAT__"